(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["siplow-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-siplow-video]').forEach(card => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      const video = card.querySelector('video');
      const button = card.querySelector('.sp-video-play');
      const error = card.querySelector('.sp-video-error');
      if (!video || !button) return;
      button.hidden = false;
      button.addEventListener('click', async () => {
        document.querySelectorAll('[data-siplow-video] video').forEach(other => { if (other !== video) other.pause(); });
        error.hidden = true;
        try { await video.play(); } catch (e) { error.hidden = false; }
      });
      video.addEventListener('play', () => { button.hidden = true; card.classList.add('is-playing'); });
      video.addEventListener('pause', () => { button.hidden = false; card.classList.remove('is-playing'); });
      video.addEventListener('ended', () => { button.hidden = false; card.classList.remove('is-playing'); });
      video.addEventListener('error', () => { error.hidden = false; });
      if ('IntersectionObserver' in window) new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) video.pause(); }), { threshold: 0.15 }).observe(video);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('[data-siplow-video] video').forEach(video => video.pause()); });
})();

  } catch(e) { console.error(e); }
})();
})();
